<script setup lang="ts">
defineProps<{
  block: BlockLinks,
  noHorizontalPadding?: boolean,
}>()
</script>

<template>
  <section class="container-d my-3" :class="{ 'px-1': !noHorizontalPadding }">
    <h2 v-if="block.label" class="label">
      {{ block.label }}
    </h2>

    <ul>
      <li v-for="item in block.links" :key="item.id ?? undefined" class="list-sep border-current first:b-t-current first:border-current flex flex-col gap-0">
        <site-payload-link 
          :data="item.link" 
          class="text-hover-accent text-sm"
        />
      </li>
    </ul>
  </section>
</template>
